import { PAGE_LOADED } from '../constants/gtmce';

const defaultOgImg = '/static/ogimage_default.png';

function getHeader (vm) {
  const { header } = vm.$options
  if (header) {
    return typeof header === 'function'
      ? header.call(vm)
      : header
  } else {
    return {}
  }
}

const serverTitleMixin = () => ({
  created () {
    this.updateHeader();
  },
  methods: {
    updateHeader: function() {
      const { title, desc, ogImg } = getHeader(this)
      this.$ssrContext.title = title 
        ? `${title} - ${this.$t('footer.contactOffice')}`
        : this.$t('footer.contactOffice');
      this.$ssrContext.ogImg = ogImg ? ogImg : defaultOgImg;
      this.$ssrContext.desc = desc ? desc : this.$t('seo.defaultDesc');
    }
  }
})

const clientTitleMixin = (options={
  firePageLoadedEvent: true
}) => ({
  mounted () {
    this.updateHeader(options);
  },
  methods: {
    updateHeader: function(options={ firePageLoadedEvent: false }) {
      const { title } = getHeader(this)
      document.title = title 
        ? `${title} - ${this.$t('footer.contactOffice')}`
        : this.$t('footer.contactOffice');
      // In client side meta desc & og:image 
      // isn't necessary need to do update

      const { firePageLoadedEvent } = options;

      if (firePageLoadedEvent) {
        setTimeout(() => {
          this.$gtmPush(PAGE_LOADED);
          this.$route.name.indexOf('sight-map-single') == 0 && this.$gtmSet('vpopular', undefined);
        }, 0);
        console.log('[GTM][HEADER UPDATED]', document.title);
      }
    }
  }
})

export default process.env.VUE_ENV === 'server'
  ? serverTitleMixin
  : clientTitleMixin
